import { combineReducers } from 'redux'

import deleteNode from './colors/delete'
import list from './colors/list'
import post from './colors/post'
import put from './colors/put'

export default combineReducers({
  delete: deleteNode,
  list,
  post,
  put
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/colors.js